import React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';
import type { Dispatch } from 'redux';
import { fetchLoginUserProfileRequest } from '@store/features/loginUserProfile/actions';
import AuthenticationFormPresentation from './AuthenticationFormPresentation.tsx'; // Import the presentational component

const mapDispatchToProps = (dispatch: Dispatch) => ({
  fetchLoginUserProfileRequest: (payload: any) =>
    dispatch(fetchLoginUserProfileRequest(payload)),
});

const connector = connect(null, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

const AuthenticationContainer: React.FC<PropsFromRedux> = ({
  fetchLoginUserProfileRequest,
}) => {
  const handleSubmit = (email: string, password: string, bot: Record<string, string>) => {
    fetchLoginUserProfileRequest({ email, password, bot });
  };

  return <AuthenticationFormPresentation onSubmit={handleSubmit} />;
};

export default connector(AuthenticationContainer);
